import React from 'react';
import { useHistory, useParams } from 'react-router-dom';
// eslint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-ignore
import { Row, Col } from 'reactstrap';
import { useDispatch } from 'react-redux';
import { useQuery, useMutation } from "graphql-hooks";

import ContentSection from '@components/common/ContentSection/ContentSection';
import ManageProducts from '@components/product/ManageProducts';
import Loader from '@components/common/Loader/Loader';
import Unavailable from '@components/common/Unavailable/Unavailable';

import { sendSuccessNotification, sendErrorNotification } from '@actions/notificationActions';

import { IProduct } from '@models/product';

const GET_PRODUCTS = `
  query GetProducts($id: ID!) {
    products {
      id
      sku
      title
    }
    group(id: $id) {
      region
      products {
        id
      }
    }
  }`;

const MODIFY_VENDOR_PRODUCTS = `
  mutation ModifyVendorProducts(
    $groupId: ID!,
    $productIds: [ID]!
  ) {
    modifyGroupProducts(
      groupId: $groupId,
      productIds: $productIds
    )
  }`;

type ParamTypes = {
  vendorId: string;
};

const ManageVendorProducts: React.FC = () => {
  const dispatch = useDispatch();
  const history = useHistory();
  const params = useParams<ParamTypes>();

  const { loading, error, data } = useQuery(GET_PRODUCTS, { variables: { id: params.vendorId } })
  const [modifyVendorProducts] = useMutation(MODIFY_VENDOR_PRODUCTS)

  const handleSubmit = async (productIds: number[]) => {
    const { data, error } = await modifyVendorProducts(
      {
        variables: {
          groupId: params.vendorId,
          productIds: productIds,
        }
      }
    )

    if (error) dispatch(sendErrorNotification(error));
    else {
      dispatch(sendSuccessNotification(`Vendor products has been modified successfully`));
      history.push('/vendors');
    }
  };

  if (loading) {
    return <Loader />;
  } else if (error) {
    dispatch(sendErrorNotification(error));
    return <Unavailable />;
  }

  return (
    <div>
      <div className="content">
        <Row>
          <Col xs={12} md={12}>
            <div className="page-title">
              <div className="float-left">
                <h1 className="title">Vendor Products</h1>
              </div>
            </div>
            <div className="col-12">
              <ContentSection>
                <ContentSection.Header>Product Management</ContentSection.Header>
                <ContentSection.Body>
                  <div className="col-lg-12 dt-disp">
                    <ManageProducts
                      region={data.group.region}
                      productIds={data.group.products.map((product: IProduct) => product.id)}
                      onSubmit={handleSubmit} />
                  </div>
                </ContentSection.Body>
              </ContentSection>
            </div>
          </Col>
        </Row>
      </div>
    </div>
  );
};

export default ManageVendorProducts;
